import(/* webpackMode: "eager", webpackExports: ["CareersContent"] */ "/vercel/path0/src/app/careers/careers-content.tsx");
